import { format } from '@dt/fe-utils'
import { payPlanMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import React from 'react'
import PaypalSimpleItem from './SimpleItem'

const PayPalMethodItem = ({ selected }: { selected?: boolean }) => {
  const amount = payPlanMobx.externalMethod?.amount

  const onClick = () => {
    if (!selected) {
      payPlanMobx.changeExternalPayMethod('PayPalWeb')
    }
  }
  return (
    <PaypalSimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('PayPalWeb')} />
  )
}

export default observer(PayPalMethodItem)
